import MtcConnectionView from './views/MtcConnectionView.vue'
import ReporteMtcView from './views/ReporteMtcView.vue'

export default [
  {
    path: 'operation',
    name: 'operation',
    component: () => import('./views/OperationView.vue'),
    meta: {
      requiresAuth: true,
      title: 'Inicio / Cierre',
      menuResource: 'INICIO_OPERACIONES'
    },
  },

  {
    path: 'mtc-connection',
    name: 'mtc-connection',
    component: MtcConnectionView,
    props: {
      title: 'Conexión con el MTC',
      subtitle: 'Diagnóstico de enlace · MTC',
      actionLabel: 'Validar conexión del MTC'
    },
    meta: {
      requiresAuth: true,
      title: 'Conexión MTC',
      menuResource: 'CONEXION',
    },
  },

  {
    path: 'reporte-mtc',
    name: 'reporte-mtc',
    component: ReporteMtcView,
    meta: {
      requiresAuth: true,
      title: 'Reporte MTC',
      menuResource: 'REPORTE_MTC',
    },
  }
]
